import { SET_AVISO_AUTOCHECK } from "../ActionTypes";

export const setAvisoAutocheck = (aviso) => (dispatch) => {
  dispatch({ type: SET_AVISO_AUTOCHECK, payload: aviso });
};
